import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { type Contact } from 'entities/Contacts/model/Contact'
import { type Integration } from 'entities/Integrations/model/Integration'
import { type MergeField } from 'entities/MergeField/model/MergeField'
import { MergeFieldsIconAction } from 'widgets/MergeField/ui/actions/MergeFieldsIconAction/MergeFieldsIconAction'

type IShortLinkMergeFieldProps = {
  contact: Contact
  integration: Integration | null
  onInsertValue: (value: string) => void
}

export const ShortLinkMergeField: FC<IShortLinkMergeFieldProps> = observer(
  ({ contact, integration, onInsertValue }) => {
    return (
      <MergeFieldsIconAction
        contact={contact}
        integration={integration}
        showOnlyWithValue
        onAddMergeField={(field: MergeField) => {
          if (field.value) {
            onInsertValue(field.value)
          }
        }}
        sizeTriggerButton='medium'
      />
    )
  }
)
